/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `not_stored` - Not Stored
* `stored_half_day` - Stored Half Day
* `stored_1_day` - Stored 1 Day
* `stored_2_days` - Stored 2 Days
* `stored_3_days` - Stored 3 Days
* `stored_5_days` - Stored 5 Days
* `stored_1_week` - Stored 1 Week
* `stored_1_half_week` - Stored 1 Half Week
* `stored_2_weeks` - Stored 2 Weeks
* `stored_3_weeks` - Stored 3 Weeks
* `stored_1_month` - Stored 1 Month
 */
export type StorageDurationEnum = typeof StorageDurationEnum[keyof typeof StorageDurationEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorageDurationEnum = {
  not_stored: 'not_stored',
  stored_half_day: 'stored_half_day',
  stored_1_day: 'stored_1_day',
  stored_2_days: 'stored_2_days',
  stored_3_days: 'stored_3_days',
  stored_5_days: 'stored_5_days',
  stored_1_week: 'stored_1_week',
  stored_1_half_week: 'stored_1_half_week',
  stored_2_weeks: 'stored_2_weeks',
  stored_3_weeks: 'stored_3_weeks',
  stored_1_month: 'stored_1_month',
} as const;
